import { LayerType, type ILayerProps } from '@meitu/saas-editor-core/es/version-types';

// 递归返回第一个文本图层
export const findFirstTextLayer = (layer: ILayerProps | null): ILayerProps | null => {
    if (!layer) return null;

    if (layer.layerType === LayerType.TEXT_LAYER) {
        return layer;
    }

    if (layer.layerType === LayerType.GROUP_LAYER) {
        for (const child of layer.children) {
            const textLayer = findFirstTextLayer(child);
            if (textLayer) {
                return textLayer;
            }
        }
    }
    return null;
};
